import Vec2 from 'vec2';

import { DrawingEdge } from '~/core/models';
import {
  ensureMutable,
  forceAssignProperty,
} from '~/core/utils/objectMutability.utils';

export const assignDisplayVectors = (
  edge: DrawingEdge,
  startVec: Vec2,
  endVec: Vec2
): DrawingEdge => {
  const mutableEdge = ensureMutable(edge);

  const startAssigned = forceAssignProperty(
    mutableEdge,
    'startDisplayVec',
    startVec
  );
  const endAssigned = forceAssignProperty(mutableEdge, 'endDisplayVec', endVec);

  if (!startAssigned || !endAssigned) {
    console.warn('Failed to assign display vectors even with force assignment');
  }

  return mutableEdge;
};
